import { render, staticRenderFns } from "./dynamicDataItem.vue?vue&type=template&id=59fbf866"
import script from "./dynamicDataItem.vue?vue&type=script&lang=js"
export * from "./dynamicDataItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports